import React from "react";
import { ICommentsCard } from "../../types/CommentsCard.types";
import { IonImg, IonItem } from "@ionic/react";
import { Button_Disclosure_Right_Grey } from "../../images/images";
import { CommentHelpers } from "../../helpers/CommentHelper";

const CommentsCard: React.FC<ICommentsCard> = (props) => {
  return (
    <IonItem button className="comments-card flex flex-col bg-white" detail={false} onClick={props.buttonPressed}>
      <div className="flex flex-col w-full p-[16px]">
        <div className="flex flex-row justify-between">
          <div className="flex items-center">
            <div className="text-acc-17px font-extrabold leading-default tracking-default text-grey-80">
              {"Comments"}
            </div>
            {typeof props.unreadCount === "number" && props.unreadCount > 0 && (
              <div className="flex min-w-[20px] h-[20px] px-[6.5px] rounded-[10px] bg-cta-red justify-center items-center mx-[6px]">
                <div className="text-[13px] font-semibold tracking-[-0.05px] text-white">{props.unreadCount}</div>
              </div>
            )}
          </div>
          <IonImg
            class="w-24px h-24px min-w-[24px] min-h-[24px] mr-[-5px] flex flex-[-1]"
            src={Button_Disclosure_Right_Grey}
          />
        </div>
        {props.latestComment && (
          <div className="mt-[8px]">
            <div className="flex flex-row justify-between">
              <div className="flex flex-row">
                {props.showNew && (
                  <div className="flex flex-row items-center">
                    <div className="text-[12px] font-medium tracking-[-0.1px] text-cta-red">{"New"}</div>
                    <div className="h-[2px] w-[2px] mx-[5px] bg-grey-70 rounded-[2px]" />
                  </div>
                )}
                <div className="text-[12px] font-semibold text-grey-90">
                  {props.latestComment.displayName}
                  {CommentHelpers.getRoleDisplayString(props.latestComment.role, props.latestComment.mentorTitle)}
                </div>
              </div>
              <div className="text-[12px] font-medium tracking-[-0.1px] text-grey-60">
                {CommentHelpers.getFormattedDate(props.latestComment.date)}
              </div>
            </div>
            <div className="mt-[4px] text-[13px] leading-[1.54] tracking-[-0.1px] text-grey-60 text-ellipsis line-clamp-2">
              {props.latestComment.comment}
            </div>
          </div>
        )}
      </div>
    </IonItem>
  );
};

export default CommentsCard;
